import styled from '@emotion/styled'
import { Breakpoints } from '../theme'
import { breakpoint } from '@the-game/components/utils'

export interface BoxBreakpointHideProps {
    breakpointProp: Breakpoints
    isReverse: Boolean
}

export const BoxBreakpointHide = styled('div')<BoxBreakpointHideProps>(
    ({ breakpointProp, isReverse }) => ({
        display: isReverse ? 'none' : 'block',
        [breakpoint(breakpointProp)]: {
            display: isReverse ? 'block' : 'none',
        },
    }),
)
